import moment from 'moment'
import React, { useEffect, useState } from 'react'
import AuthService from '../../Components/auth/AuthService';
import { Descriptions, Table, Tag, Image, Divider, Statistic, Col, Card, Row, Input, Collapse, Button, Tooltip, Typography, Space, Badge } from 'antd';
import { netsuite_url, tms_uploads_cdn, env } from '../../Components/config';
import { CheckOutlined, CloseCircleOutlined, CloseOutlined, CloudDownloadOutlined, EyeFilled, InfoCircleOutlined } from '@ant-design/icons';
import { makeStyles } from "@mui/styles";
import { deliveryStatuses } from '../../Components/common/constants';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import Message from '../../Components/common/Message';
import { formatCurrency } from '../../Components/common/CommonFun';
import DetailsModal from './DetailsModal';

const useStyles = makeStyles((theme) => ({
  dataSheet: {
    padding: '10px',
    "& .ant-card .ant-card-body": {
      padding: "4px",
      // backgroundColor: 'rgb(240, 240, 240)',
    },

    "& .ant-statistic .ant-statistic-content": {
      fontSize: "12px",
      fontWeight: "bold",
    },
    "& .ant-statistic .ant-statistic-title": {
      fontSize: "12px",
    },
    "& .ant-input[disabled]": {
      color: 'black !important',
      fontWeight: 500
    },
    "& .ant-card-bordered": {
      border: '1px solid #b1aeae'
    }

  },
  antTable: {
    "& .ant-table-tbody > tr > td": {
      borderBottom: "1px solid #b7b9bd",
    },
    "& .ant-table-footer": {
      padding: '16px 0px !important'
    }
  },
}));

const CashupTab = ({ cashUpData, setCashUpData, delivery_date, paymentAuthorizer, updateCashup }) => {

  const Auth = new AuthService();
  const classes = useStyles();
  const { TextArea } = Input
  const { Panel } = Collapse;
  const { Text } = Typography;

  var layoutDispatch = useLoadingDispatch();

  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("");

  const [filesOpen, setFilesOpen] = React.useState(false);
  const [selectedRecord, setSelectedRecord] = React.useState("");


  const handleFilesOpen = (row) => {
    console.log("row", row);
    if (row) {
      setSelectedRecord(row);
    }
    setFilesOpen(true);
  };
  const handleFilesClose = () => setFilesOpen(false);

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return <Tag color="warning">Pending</Tag>;
      case 2:
        return <Tag color="success">Approved</Tag>;
      case 3:
        return <Tag color="error">Rejected</Tag>;
      default:
        return "";
    }
  };

  const [disabledRoutes, setDisabledRoutes] = React.useState([]);


  useEffect(() => {
    localStorage.setItem("disabledCashupRoutes", JSON.stringify(disabledRoutes));
  }, [disabledRoutes]);

  useEffect(() => {
    // Retrieve previously stored disabledRoutes from localStorage
    if (cashUpData?.length) {
      const storedDisabledRoutes = JSON.parse(localStorage.getItem("disabledCashupRoutes")) || [];

      const newDisabledRoutes = cashUpData?.filter(stock => stock.credit_notes_posted_by > 0)
        .map(stock => stock.routeStatusID);

      // Merge stored disabledRoutes with new ones, avoiding duplicates
      const updatedDisabledRoutes = [...new Set([...storedDisabledRoutes, ...newDisabledRoutes])];

      // Update the state and localStorage
      setDisabledRoutes(updatedDisabledRoutes);
      localStorage.setItem("disabledCashupRoutes", JSON.stringify(updatedDisabledRoutes));
    }

  }, [cashUpData]);

  const handleInputChange = (index, fieldName, value) => {
    const updatedCashUpData = [...cashUpData];
    updatedCashUpData[index][fieldName] = value;
    setCashUpData(updatedCashUpData);
  };

  const onFinish = async (dataIndex) => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }
    showLoading(layoutDispatch);
    const routeStatusID = cashUpData[dataIndex].routeStatusID;
    const cash = cashUpData[dataIndex].cashReceived;
    const card = cashUpData[dataIndex].cardReceived;
    const dataToSend = {
      route_status_id: routeStatusID,
      cash_received: cash,
      card_received: card,
    };
    try {
      const response = await Auth.fetch("/route/update-amount-received-route", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (response.ack) {
        setType('success')
        setLoadMessage(response?.message + str)
        const updatedDisabledRoutes = [...disabledRoutes, routeStatusID];
        setDisabledRoutes(updatedDisabledRoutes);
        localStorage.setItem(
          "disabledCashupRoutes",
          JSON.stringify(updatedDisabledRoutes)
        );

        updateCashup(cash, card)
      } else {
        setType('error')
        setLoadMessage(response?.message + str)
      }
    } catch (error) {
      console.log(error);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const itemColumns = [
    {
      title: "S No.",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (text, record, index) => index + 1,
      // width: 40,
    },
    {
      title: "Code",
      dataIndex: "itemId",
      key: "itemId",
      // width: 40,
    },
    {
      title: "Name",
      dataIndex: "itemName",
      key: "itemName",
      // width: 250,
    },
    {
      title: "QTY",
      dataIndex: "quantity",
      key: "quantity",
      // width: 75,
      align: 'center',
    },
    {
      title: "Delivered QTY",
      dataIndex: "deliveredQuantity",
      key: "deliveredQuantity",
      // width: 75,
      align: 'center',
    },
    {
      title: "Status",
      align: 'center',
      render: (record) => {
        const status = deliveryStatuses.find(item => item.id === record?.deliveryStatus)
        return (
          <span>{status ? status.title : ''}</span>
        );
      },
      // width: 75,
    },
  ];

  const dataCol = [
    {
      title: "S.No.",
      dataIndex: "rank",
      key: "rank",
      // width: 55
    },
    // {
    //   title: "Shop Code",
    //   dataIndex: "customerName",
    //   key: "customerName",
    //   width: 100
    // },
    {
      title: "Shop Code",
      // dataIndex: "customerName",
      // key: "customerName",
      render: (text, record) => {
        return <span><a href={`${netsuite_url}/app/common/entity/custjob.nl?id=${record.customerInternalId}`} target="_blank">{record.customerName}</a></span>;
      },
      // width: 100
    },
    {
      title: "Shop Name",
      dataIndex: "customerProjectId",
      key: "customerProjectId",
      // width: 200
    },
    // {
    //   title: "Invoice",
    //   dataIndex: "invoice_no",
    //   key: "invoice_no",
    //   width: 100
    // },

    {
      title: 'Order',
      render: (text, record) => {
        return (
          <span>

            <a
              href={`${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record?.internalId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {record?.saleOrderNo}
            </a>
          </span>
        );
      },
      // width: 100
    },
    {
      title: 'Invoice',
      render: (text, record) => {
        return (
          <span>
            <a
              href={`${netsuite_url}/app/accounting/transactions/custinvc.nl?id=${record?.invoiceInternalId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {record?.invoice_no}
            </a>

          </span>
        );
      },
      // width: 100
    },
    // {
    //   title: 'Order No.',
    //   render: (text, record) => {
    //       return (
    //           <span>
    //               {record.invoice_no != null && record?.invoice_no != "" ? (
    //                   <a 
    //                       href={`${netsuite_url}/app/accounting/transactions/custinvc.nl?id=${record.invoiceInternalId}`} 
    //                       target="_blank" 
    //                       rel="noopener noreferrer"
    //                   >
    //                       {record.invoice_no}
    //                   </a>
    //               ) : (
    //                   <a 
    //                       href={`${netsuite_url}/app/accounting/transactions/salesord.nl?id=${record.internalId}`} 
    //                       target="_blank" 
    //                       rel="noopener noreferrer"
    //                   >
    //                       {record.saleOrderNo}
    //                   </a>
    //               )}
    //           </span>
    //       );
    //   },
    //   width: 100
    // },
    {
      title: "Total (£)",
      dataIndex: "orderAmount",
      key: "orderAmount",
      // render: (text, record) => {
      //   const orderAmount = Number(record.orderAmount).toLocaleString("en-GB");
      //   return `${orderAmount}`;
      // },
      render: (text, record) => Number(record.orderAmount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) || '0.00',
      // width: 100
    },
    {
      title: "Cash",
      dataIndex: "amountReceivedCash",
      key: "amountReceivedCash",
      render: (text, record) => Number(record.amountReceivedCash).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) || '0.00',
      // width: 100
    },
    {
      title: "Card",
      dataIndex: "amountReceivedCard",
      key: "amountReceivedCard",
      render: (text, record) => Number(record.amountReceivedCard).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) || '0.00',
      // width: 100
    },
    // {
    //   title: "Bank",
    //   dataIndex: "amountReceivedAccount",
    //   key: "amountReceivedAccount",
    //   render: (text, record) => Number(record.amountReceivedAccount).toLocaleString(undefined, {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2
    //   }) || '0.00',
    //   width: 100
    // },
    {
      title: "Status",
      render(record) {
        let statusText;
        let backgroundColor;
        // let delivered_at = record?.delivered_at || "N/A";
        const delivered_at = record?.delivered_at && moment(record.delivered_at).isValid()
          ? moment(record.delivered_at).format('YYYY-MM-DD HH:mm:ss')
          : "N/A";

        switch (record?.delivered) {
          case 1:
            statusText = "Delivered";
            backgroundColor = "#80cb80";
            break;
          case 2:
            statusText = "Postponed";
            backgroundColor = "#f0d787";
            break;
          case -1:
            statusText = "Submitted";
            backgroundColor = "#1890FF";
            break;
          default:
            statusText = "Not Delivered";
            backgroundColor = "#edb1a7";
            break;
        }

        return {
          props: {
            style: {
              background: backgroundColor,
              textAlign: 'center',

            },
          },
          children: (
            <>
              {statusText}
              {record?.delivered === 1 && (
                <Tooltip title={`Delivered at: ${delivered_at}`}>
                  <InfoCircleOutlined style={{ marginLeft: 8, color: "#000" }} />
                </Tooltip>
              )}
            </>
          ),
        };
      },
      // width: 100
    },
    {
      title: "Action",
      align: "center",
      // width: 75,
      render(record) {
        return (
          // <EyeFilled
          //   style={{ cursor: "pointer", fontSize: "25px" }}
          //   onClick={() => {
          //     handleFilesOpen(record);
          //   }}
          // />
          <Badge
            color="#1890ff"
            dot={record?.delivery_instructions || record?.notes || record?.payment_req_notes || record?.delivery_discout_notes || record?.postponed_notes}
          >
            <EyeFilled
              style={{ cursor: "pointer", fontSize: "25px" }}
              onClick={() => {
                handleFilesOpen(record);
              }}
            />
          </Badge>
        );
      },
    },
  ];

  const genExtraContent = (updatedCashUpData1) => (
    <>
      {(updatedCashUpData1[0]?.totalCash > 0 && updatedCashUpData1[0]?.dc_grand_total == 0) && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CloseCircleOutlined style={{ color: 'red', fontSize: '18px', marginRight: '4px' }} /><span style={{ color: 'red', fontSize: '15px' }}>Cash Up Not Found </span>
        </div>
      )
      }
    </>
  );

  // Define the values for coins and notes
  const coinValues = {
    dc_one_pennies_coins: 0.01,
    dc_two_pennies_coins: 0.02,
    dc_five_pennies_coins: 0.05,
    dc_ten_pennies_coins: 0.10,
    dc_twenty_pennies_coins: 0.20,
    dc_fifty_pennies_coins: 0.50,
    dc_one_pound_coins: 1.00,
    dc_two_pound_coins: 2.00,
  };

  const noteValues = {
    dc_five_notes: 5,
    dc_ten_notes: 10,
    dc_twenty_notes: 20,
    dc_fifty_notes: 50,
  };

  // Function to calculate total coins and notes
  const calculateTotals = (data) => {
    let totalCoins = 0;
    let totalNotes = 0;

    Object.keys(coinValues).forEach((key) => {
      totalCoins += (data[key] || 0) * coinValues[key];
    });

    Object.keys(noteValues).forEach((key) => {
      totalNotes += (data[key] || 0) * noteValues[key];
    });

    return {
      ...data,
      dc_change_total: totalCoins,
      dc_notes_total: totalNotes,
      dc_grand_total: totalCoins + totalNotes,
    };
  };

  const updatedCashUpData = cashUpData?.map(calculateTotals)

  const downloadCSVFile = (id) => {
    const dataObject = cashUpData.find((item, idx) => idx === id);
    console.log('dataObject', dataObject);

    // Extract formatted_date and driver fields
    const formattedDate = dataObject.formatted_date.replace(/ /g, '-'); // Replace spaces with dashes
    const driverName = dataObject.driver.replace(/\s+/g, ''); // Remove spaces

    // Define the filename
    const filename = `${formattedDate}_${dataObject.driverRoute}_cashUp.csv`;

    // Define fields to exclude
    const excludedFields = ['expanded', 'formatted_date', 'routeStatusID'];

    // Define a mapping object to rename tableData headers
    const tableDataHeaderMapping = {
      rank: 'S No.',
      customerName: 'Shop Code',
      customerProjectId: 'Shop Name',
      invoice_no: 'Invoice No',
      orderAmount: 'Total',
      amountReceivedCash: 'Cash',
      amountReceivedCard: 'Card',
      amountReceivedAccount: 'Bank'
    };

    // Define fields to exclude from tableData
    const excludedTableDataFields = ['invoiceInternalId', 'palletOrderID', 'customerInternalId'];

    // Define the desired order for simple fields and table fields
    const simpleFieldsOrder = [
      'route', 'driver', 'truck', 'driverRoute', 'terminal',
      'totalCash', 'totalCard', 'totalAccount', 'cardReceived', 'cashReceived'
    ];
    const tableFieldsOrder = [
      'rank', 'customerName', 'customerProjectId', 'invoice_no',
      'orderAmount', 'amountReceivedCash', 'amountReceivedCard', 'amountReceivedAccount'
    ];

    // Filter and map the simple fields according to the desired order
    const simpleFields = simpleFieldsOrder.filter(field => dataObject.hasOwnProperty(field) && !excludedFields.includes(field));

    // Format simple fields data into CSV string
    let csvData = '';

    simpleFields.forEach(field => {
      let fieldName = field;
      let fieldValue = dataObject[field];

      if (field === 'route') fieldName = 'Route No';
      if (field === 'driver') fieldName = 'Driver';
      if (field === 'truck') fieldName = 'Truck Reg.';
      if (field === 'driverRoute') fieldName = 'Route';
      if (field === 'terminal') {
        fieldName = 'CC Terminal No.';
        // fieldValue = `C${fieldValue}`;
        fieldValue = fieldValue ? `C${fieldValue}` : ''
      }
      if (field === 'totalCash') fieldName = 'Total Cash';
      if (field === 'totalCard') fieldName = 'Total Card';
      if (field === 'totalAccount') fieldName = 'Total Account';
      if (field === 'cardReceived') fieldName = 'Total Card Received';
      if (field === 'cashReceived') fieldName = 'Total Cash Received';

      csvData += `${fieldName},${fieldValue}\n`;
    });

    // Process tableData if it exists
    if (dataObject.tableData) {
      // Extract tableData headers
      const tableHeaders = Object.keys(dataObject.tableData[0]);
      // Map headers to their renamed counterparts and exclude unwanted fields
      const renamedHeaders = tableFieldsOrder
        .filter(header => tableHeaders.includes(header) && !excludedTableDataFields.includes(header))
        .map(header => tableDataHeaderMapping[header] || header);
      // Add tableData headers to CSV
      csvData += `${renamedHeaders.join(',')}\n`;

      // Loop through each row in tableData and add to CSV
      dataObject.tableData.forEach(row => {
        const rowData = tableFieldsOrder
          .filter(key => !excludedTableDataFields.includes(key))
          .map(key => row[key]);
        csvData += `${rowData.join(',')}\n`;
      });
    }

    // Create a Blob object from the CSV data
    const blob = new Blob([csvData], { type: 'text/csv' });

    // Create a temporary URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);

    // Append the link to the body and click it to trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up: remove the link and revoke the URL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const genExtra = (idx, data) => {

    const posted = updatedCashUpData[0]?.cashup_updated_by > 0 ? true : false;
    const completed = updatedCashUpData[0]?.start_status === 2 ? true : false;
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* <Button
            style={{
              marginRight: '5px',
              color: completed  ? 'green' : 'red',
              cursor: 'alias',
              pointerEvents: "none",
              padding: '4px 4px'
            }}
            icon={completed ? <CheckOutlined/> : <CloseOutlined />}
              >
               Route Completed
          </Button> */}
        <Button
          style={{
            marginRight: '5px',
            color: posted || disabledRoutes.includes(updatedCashUpData[0].routeStatusID) ? 'green' : 'red',
            cursor: 'alias',
            pointerEvents: "none",
            padding: '4px 4px'
          }}
          icon={posted || disabledRoutes.includes(updatedCashUpData[0].routeStatusID) ? <CheckOutlined /> : <CloseOutlined />}
        >
          Warehouse Cashup
        </Button>

        <Button
          style={{
            marginRight: '5px',
            color: updatedCashUpData[0]?.cashup_signature ? 'green' : 'red',
            cursor: 'alias',
            pointerEvents: "none",
            padding: '4px 4px'
          }}
          icon={updatedCashUpData[0]?.cashup_signature ? <CheckOutlined /> : <CloseOutlined />}
        >
          Driver Cashup
        </Button>

        <Tooltip title="Download">
          <CloudDownloadOutlined
            style={{ fontSize: '25px', color: '#1677FF' }}
            onClick={(e) => {
              // e.stopPropagation();
              downloadCSVFile(0);
            }}
          />
        </Tooltip>
      </div>
    )
  };

  const rowClassName = (record) => {
    const status = deliveryStatuses.find(item => item.id === record?.deliveryStatus);
    if (status?.title !== 'Delivered') {
      return 'highlight-row';
    }
    return '';
  };


  return (
    <>
      <div className={classes.dataSheet}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
          <div style={{ padding: '5px' }}>{genExtra()}</div>
        </div>


        <Row gutter={[6, 16]} style={{ marginTop: "10px" }}>
          <Col span={12}>
            <Row
              gutter={[4, 4]}
              style={{
                background: "#f0f2f5",
                padding: "4px",
                borderRadius: "8px",
              }}
            >
              {/* Cash Section */}
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <div
                  style={{
                    background: "#ffffff",
                    padding: "4px",
                    borderRadius: "8px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    border: '2px solid #b1aeae'
                  }}
                >
                  <Row gutter={[6, 6]}>
                    <Col xs={24} sm={24} md={8}>
                      <Card>
                        <Statistic
                          title="Total Cash"
                          value={formatCurrency(updatedCashUpData[0]?.totalCash)}
                          valueStyle={{
                            color: "#1677FF",
                          }}
                        />
                      </Card>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Card>
                        <Statistic
                          title="Cash Received"
                          value={formatCurrency(updatedCashUpData[0]?.cashReceived)}

                          valueStyle={{
                            color: "#1677FF"

                          }}
                        />
                      </Card>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Card>
                        <Statistic
                          title="Difference"
                          value={formatCurrency(updatedCashUpData[0]?.cashReceived - updatedCashUpData[0]?.totalCash)}
                          valueStyle={{
                            color: updatedCashUpData[0]?.cashReceived - updatedCashUpData[0]?.totalCash > 0
                              ? "green"
                              : updatedCashUpData[0]?.cashReceived - updatedCashUpData[0]?.totalCash === 0
                                ? "blue"
                                : "red"


                          }}
                        />
                      </Card>
                    </Col>

                  </Row>
                </div>
              </Col>

              {/* Card Section */}
              <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                <div
                  style={{
                    background: "#ffffff",
                    padding: "4px",
                    borderRadius: "8px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    border: '2px solid #b1aeae'

                  }}
                >
                  <Row gutter={[6, 6]}>
                    <Col xs={24} sm={24} md={8}>
                      <Card>
                        <Statistic
                          title="Total Card"
                          value={formatCurrency(updatedCashUpData[0]?.totalCard)}
                          valueStyle={{
                            color: "#1677FF",
                          }}
                        />
                      </Card>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Card>
                        <Statistic
                          title="Card Received"
                          value={formatCurrency(updatedCashUpData[0]?.cardReceived)}

                          valueStyle={{
                            color: "#1677FF"

                          }}
                        />
                      </Card>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Card>
                        <Statistic
                          title="Difference"
                          value={formatCurrency(updatedCashUpData[0]?.cardReceived - updatedCashUpData[0]?.totalCard)}
                          valueStyle={{
                            color: updatedCashUpData[0]?.cardReceived - updatedCashUpData[0]?.totalCard > 0
                              ? "green"
                              : updatedCashUpData[0]?.cardReceived - updatedCashUpData[0]?.totalCard === 0
                                ? "#1677FF"
                                : "red"
                          }}
                        />
                      </Card>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
          <Col style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }} span={12}>
            <div   >
              <Space gutter={16}>
                {/* <Col span={8}> */}
                <Text>Cash Received</Text>
                <Input
                  type="number"
                  name="cash"
                  style={{
                    width: "100%",
                  }}
                  placeholder="Cash received"
                  value={updatedCashUpData[0]?.cashReceived ? updatedCashUpData[0]?.cashReceived : null}
                  onChange={(e) =>
                    handleInputChange(0, "cashReceived", e.target.value)
                  }
                />
                {/* </Col> */}
                {/* <Col span={8}> */}
                <Text>Card Received</Text>
                <Input
                  name="card"
                  type="number"
                  style={{
                    width: "100%",
                  }}
                  placeholder="Card received"
                  value={updatedCashUpData[0]?.cardReceived ? updatedCashUpData[0]?.cardReceived : null}
                  onChange={(e) =>
                    handleInputChange(0, "cardReceived", e.target.value)
                  }
                />
                {/* </Col> */}
                {/* <Col span={8}> */}
                <Button type="primary" onClick={() => onFinish(0)}>
                  Save
                </Button>
                {/* </Col> */}
              </Space>
            </div>
          </Col>
        </Row>

        <Collapse style={{ margin: "10px 0px" }} >
          <Panel
            header={
              <>
                <span style={{ fontWeight: "bold" }}>
                  Cash Up Details
                </span>
              </>
            }
            extra={genExtraContent(updatedCashUpData)}
          >
            <Descriptions bordered size={'small'} >
              <Descriptions.Item label={`£50`}> Count: {updatedCashUpData[0]?.dc_fifty_notes || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_fifty_notes ? parseInt(updatedCashUpData[0]?.dc_fifty_notes) * 50.00 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£20`}> Count: {updatedCashUpData[0]?.dc_twenty_notes || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_twenty_notes ? parseInt(updatedCashUpData[0]?.dc_twenty_notes) * 20.00 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£10`}> Count: {updatedCashUpData[0]?.dc_ten_notes || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_ten_notes ? parseInt(updatedCashUpData[0]?.dc_ten_notes) * 10.00 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£5`}> Count: {updatedCashUpData[0]?.dc_five_notes || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_five_notes ? parseInt(updatedCashUpData[0]?.dc_five_notes) * 5.00 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£2`}> Count: {updatedCashUpData[0]?.dc_two_pound_coins || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_two_pound_coins ? parseInt(updatedCashUpData[0]?.dc_two_pound_coins) * 2.00 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£1`}> Count: {updatedCashUpData[0]?.dc_one_pound_coins || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_one_pound_coins ? parseInt(updatedCashUpData[0]?.dc_one_pound_coins) * 1.00 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£50p`}> Count: {updatedCashUpData[0]?.dc_fifty_pennies_coins || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_fifty_pennies_coins ? parseInt(updatedCashUpData[0]?.dc_fifty_pennies_coins) * 0.50 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£20p`}> Count: {updatedCashUpData[0]?.dc_twenty_pennies_coins || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_twenty_pennies_coins ? parseInt(updatedCashUpData[0]?.dc_twenty_pennies_coins) * 0.20 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£10p`}> Count: {updatedCashUpData[0]?.dc_ten_pennies_coins || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_ten_pennies_coins ? parseInt(updatedCashUpData[0]?.dc_ten_pennies_coins) * 0.10 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£5p`}> Count: {updatedCashUpData[0]?.dc_five_pennies_coins || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_five_pennies_coins ? parseInt(updatedCashUpData[0]?.dc_five_pennies_coins) * 0.05 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£2p`}> Count: {updatedCashUpData[0]?.dc_two_pennies_coins || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_two_pennies_coins ? parseInt(updatedCashUpData[0]?.dc_two_pennies_coins) * 0.02 : 0).toFixed(2)}</Descriptions.Item>
              <Descriptions.Item label={`£1p`}> Count: {updatedCashUpData[0]?.dc_one_pennies_coins || 0}
                <br />
                Total: {"£" + (updatedCashUpData[0]?.dc_one_pennies_coins ? parseInt(updatedCashUpData[0]?.dc_one_pennies_coins) * 0.01 : 0).toFixed(2)}</Descriptions.Item>

            </Descriptions>

            <Row gutter={[6, 16]}>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                  Total Coin
                </h4>
                <Input
                  placeholder=" Total Coins Amount"
                  disabled
                  type="number"
                  value={updatedCashUpData[0]?.dc_change_total ? updatedCashUpData[0]?.dc_change_total.toFixed(2) : 0}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                  Total Notes
                </h4>
                <Input
                  placeholder=" Total Notes Amount"
                  disabled
                  type="number"
                  value={updatedCashUpData[0]?.dc_notes_total ? updatedCashUpData[0]?.dc_notes_total.toFixed(2) : 0}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                  Grand Total
                </h4>
                <Input
                  placeholder=" Total Amount"
                  disabled
                  type="number"
                  value={updatedCashUpData[0]?.dc_grand_total ? updatedCashUpData[0]?.dc_grand_total.toFixed(2) : 0}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                  Notes
                </h4>
                <TextArea
                  autoSize
                  placeholder="Notes"
                  disabled
                  // type="number"
                  value={updatedCashUpData[0]?.dc_notes}
                />
              </Col>
            </Row>
            {updatedCashUpData[0]?.dc_files?.length > 0 && <h4>Files:</h4>}
            <br />
            <Image.PreviewGroup>
              {updatedCashUpData[0]?.dc_files?.length > 0 &&
                updatedCashUpData[0]?.dc_files
                  .map((item) => {
                    const imageUrl = `${tms_uploads_cdn}/${env
                      }/cashup/${updatedCashUpData[0]?.routeStatusID}/${item}`;
                    return (
                      <div
                        style={{
                          position: "relative",
                          marginRight: "10px",
                          display: "inline-block",
                        }}
                      >
                        <Image
                          width={200}
                          height={150}
                          style={{
                            padding: "5px",
                            border: "1px solid lightgrey",
                          }}
                          src={imageUrl}
                        />
                      </div>
                    );
                  })}
            </Image.PreviewGroup>
            <Divider />

          </Panel>
        </Collapse>

        <>
          <Table
            style={{  marginTop: "10px" }}
            scroll={{ x: 'max-content'}}
            columns={dataCol}
            bordered
            dataSource={updatedCashUpData[0]?.tableData}
            pagination={false}
          // scroll={{
          //   y: 300,
          // }}
          />
        </>

      </div>
      <DetailsModal filesOpen={filesOpen} handleFilesClose={handleFilesClose} selectedRecord={selectedRecord} itemColumns={itemColumns} getStatusText={getStatusText} paymentAuthorizer={paymentAuthorizer} classes={classes} rowClassName={rowClassName} delivery_date={delivery_date} />


      <Message type={type} msg={loadMessage} />

    </>
  )
}

export default CashupTab
